import React, {Component} from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import Icons from '../Icons';

class MenuLeft extends Component {
  constructor(){
    super();
    this.state={

    }
  }
  render() {
    let {icons, funct, logout} = this.props;

    if (icons === "admin"){
      if (parseInt(this.props.uPer, 10) === 1) {
        return (
          <div id="MenuLeft">
            <NavLink 
              to="/home/admin"
              className={"MenuLeft Icon " + icons}>
              <Icons name={icons} />
            </NavLink>
          </div>
        )
      } else {
        return (
          <div id="MenuLeft" className="Icon" onClick={() => logout()}>
            <Icons name="logout" />
          </div>
        )
      }
    } else if (icons === "ok"){
      return (
        <div id="MenuLeft">
          <NavLink 
            to="/home/tableros" 
            className={"Icon"} 
            onClick={() => funct()}>
              <Icons name="ok" />
          </NavLink>
        </div>
      )
    } else if (icons === "savecard"){
      return (
        <div id="MenuLeft">
          <NavLink 
            to="/home/tableros" 
            className={"MenuRight Icon " + icons} 
            onClick={() => funct()}>
              <Icons name={icons} />
          </NavLink>
        </div>
      )
    } else if (icons === "arrowThin"){
      return (
        <div id="MenuLeft">
          <a 
            onClick={this.props.history.goBack}
            className={"MenuRight Icon " + icons}>
              <Icons name={icons} />
          </a>
        </div>
      )
    }
  }
}
 

export default withRouter(MenuLeft);


// WEBPACK FOOTER //
// ./src/Containers/Nav/MenuLeft.js